"use client";

import { useState } from "react";
import posthog from "posthog-js";

/** Web Share where it exists (mobile), clipboard copy elsewhere. */
export function ShareButton() {
  const [label, setLabel] = useState("Share");

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Viskhan Khasiyev · Resume",
          text: "Resume of Viskhan Khasiyev, design engineer.",
          url,
        });
        posthog.capture("resume_shared", { method: "native_share" });
        return;
      }
      await navigator.clipboard.writeText(url);
      posthog.capture("resume_shared", { method: "clipboard" });
      setLabel("Link copied");
      setTimeout(() => setLabel("Share"), 1600);
    } catch {
      // User cancelled or share failed; no-op.
    }
  };

  return (
    <button type="button" className="oi-btn" onClick={handleShare}>
      {label}
    </button>
  );
}
